module.exports = __webpack_public_path__ + "img/SL410BT.56e62e9c.png";